/**
 * Normalise une valeur du magasin reactive-json en TABLEAU.
 *
 * Pourquoi : l'élément `DataFilter` (filtrage local d'une liste, cf.
 * `front_app/public/pages/doc/hub.yaml`) rend à ses enfants une COPIE de tout
 * l'arbre de données où chaque tableau est devenu un objet indexé
 * (`['a','b']` → `{0:'a', 1:'b'}`) — pas seulement la liste filtrée. Un
 * composant qui teste `Array.isArray()` y voit donc une liste vide, et un
 * composant qui appelle `.map()` / `.find()` casse le rendu de l'écran, dans
 * les deux cas sans erreur explicite.
 *
 * Tout composant susceptible d'être rendu SOUS un `DataFilter` lit ses
 * collections à travers cette fonction.
 */
export const toList = (value) => {
  if (Array.isArray(value)) return value;
  if (value && typeof value === 'object') return Object.values(value);
  return [];
};
